import React, {useState} from 'react';
import Button from '@mui/material/Button';
import { Select, Slider, InputNumber, Space, Divider, Typography, Form } from 'antd';
import { debounce } from 'lodash';
import NumberInput from '../../components/Inputs/NumberInput';
const { Option } = Select;
const { Text } = Typography;

const tickers = [
  'SPY', 'QQQ', 'VTV', 'RPV', 'RPG', 'IWR', 'IWN', 'IWO', 'IWP', 'VBR', 'AGG', 'BND',
];

const MetricLabels = {
  beta: "Beta",
  sharpe: "Sharpe Ratio",
  upside_capture: "Upside Capture",
  downside_capture: "Downside Capture",
  r2: "R-Squared",
  correlate: "Correlation (Pearson)",
};

const RelativeMetricToolbar = ({
  metric,
  setMetric,
  targetSymbol,
  setTargetSymbol,
  window,
  setWindow,
  direction = 'vertical'  // default direction is vertical
}) => {
  const metrics = Object.keys({ ...MetricLabels });

  // Debounced function for setTargetSymbol
  const [tempWindow, setTempWindow] = useState(window);
  const debouncedSetTargetSymbol = debounce(value => setTargetSymbol(value), 300);

  // Debounced function for setWindow
  const debouncedSetWindow = debounce(value => setWindow(value), 300);

  return (
    <Form layout={direction}>
      <Space
        direction={direction}
        size="large"
        align={direction === 'vertical' ? 'start' : 'center'}
        style={{ width: '100%' }}
      >

        <Form.Item label={<Typography.Text strong>Metric</Typography.Text>} style={{ marginBottom: 0 }}>
          <Select
            value={metric}
            onChange={setMetric}
            style={{ width: 200 }}
          >
            {metrics.map(m => (
              <Option key={m} value={m}>{MetricLabels[m]}</Option>
            ))}
          </Select>
        </Form.Item>

        <Divider type={direction === 'vertical' ? 'horizontal' : 'vertical'} style={{ margin: 0 }} />
        <Typography.Text strong>Benchmark</Typography.Text>
        <Form.Item style={{ marginBottom: 0 }}>
          <Select
            placeholder="Select Ticker"
            value={targetSymbol}
            onChange={value => debouncedSetTargetSymbol(value)}
            style={{ width: direction==='vertical' ? 200 : 125 }}
            dropdownRender={menu => (
              <div>
                <div style={{
                  display: 'grid',
                  gridTemplateColumns: 'repeat(auto-fill, minmax(50px, 1fr))',
                  gap: '4px',
                  padding: '4px'
                }}>
                  {tickers.map(ticker => (
                    <div
                      key={ticker}
                      style={{ padding: '8px', textAlign: 'center', cursor: 'pointer' }}
                      onClick={() => debouncedSetTargetSymbol(ticker.toLowerCase())}
                    >
                      {ticker}
                    </div>
                  ))}
                </div>
                {menu}
              </div>
            )}
          />
        </Form.Item>

        <Divider type={direction === 'vertical' ? 'horizontal' : 'vertical'} style={{ margin: 0 }} />

        <Form.Item label="Window Size" style={{ marginBottom: 0 }}>
          <Space direction="vertical" style={{ width: 200 }}>
            <NumberInput value={tempWindow} onSubmit={setTempWindow}  />

            <Button onClick={()=>setWindow(tempWindow)}>Submit</Button>

          </Space>
        </Form.Item>

      </Space>
    </Form>
  );
};

export default RelativeMetricToolbar;
